"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.PaginationPageTypes = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Pagination_1 = require("@material-ui/lab/Pagination");
var Pagination_styles_1 = require("./Pagination.styles");
var core_1 = require("@material-ui/core");
var TypographyColor_1 = require("../../enums/TypographyColor");
var PaginationPageTypes;
(function (PaginationPageTypes) {
    PaginationPageTypes["first"] = "first";
    PaginationPageTypes["previous"] = "previous";
    PaginationPageTypes["startEllipsis"] = "start-ellipsis";
    PaginationPageTypes["endEllipsis"] = "end-ellipsis";
    PaginationPageTypes["page"] = "page";
    PaginationPageTypes["next"] = "next";
})(PaginationPageTypes = exports.PaginationPageTypes || (exports.PaginationPageTypes = {}));
var Pagination = function (_a) {
    var limit = _a.limit, totalCount = _a.totalCount, page = _a.page, _b = _a.prevButtonText, prevButtonText = _b === void 0 ? 'Previous' : _b, _c = _a.nextButtonText, nextButtonText = _c === void 0 ? 'Next' : _c, _d = _a.name, name = _d === void 0 ? 'default' : _d, handlePaginationUpdate = _a.handlePaginationUpdate;
    var classes = (0, Pagination_styles_1.usePaginationStyles)();
    var PREVIOUS_SYMBOL = '< \u00A0\u00A0';
    var NEXT_SYMBOL = '\u00A0\u00A0 >';
    var pagesCount = totalCount / limit;
    var items = (0, Pagination_1.usePagination)({
        count: Math.ceil(pagesCount),
        boundaryCount: 1,
        page: page,
    }).items;
    return (react_1.default.createElement("nav", { className: classes.nav, "data-signa": "".concat(name, "-pagination") },
        react_1.default.createElement("ul", { className: classes.ul }, items.map(function (_a, index) {
            var page = _a.page, type = _a.type, selected = _a.selected, disabled = _a.disabled, onClick = _a.onClick, item = tslib_1.__rest(_a, ["page", "type", "selected", "disabled", "onClick"]);
            var children = null;
            var itemInfo = {
                type: type,
                page: page,
                selected: selected,
                disabled: disabled,
            };
            var handleOnclick = function (event) {
                return handlePaginationUpdate(event, itemInfo);
            };
            if (type === PaginationPageTypes.startEllipsis || type === PaginationPageTypes.endEllipsis) {
                children = '…';
            }
            else if (type === PaginationPageTypes.page) {
                children = (react_1.default.createElement("div", tslib_1.__assign({}, item),
                    react_1.default.createElement(core_1.Typography, { className: selected ? classes.selectedFont : '', "data-signa": "pagination-page-".concat(index), color: TypographyColor_1.TypographyColor.primary, variant: "body2" }, page)));
            }
            else {
                children = (react_1.default.createElement(core_1.Typography, { "data-signa": "pagination-type-".concat(type), color: disabled ? TypographyColor_1.TypographyColor.textPrimary : TypographyColor_1.TypographyColor.primary, variant: "body2" }, type === PaginationPageTypes.previous
                    ? "".concat(PREVIOUS_SYMBOL).concat(prevButtonText)
                    : "".concat(nextButtonText).concat(NEXT_SYMBOL)));
            }
            return (react_1.default.createElement("li", { className: selected ? classes.selectedLi : disabled ? classes.disabled : classes.li, key: index, onClick: handleOnclick, "data-signa": "pagination-li-".concat(index) }, children));
        }))));
};
exports.Pagination = Pagination;
